import React from 'react';
import Logo from '../../assets/common/new-era-logo-white.png';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const MobileFooter = () => {
  return (
  <footer className="bg-blue text-white py-10 cursor-pointer text-sm">
  <div className="max-w-screen mx-auto flex flex-col items-center justify-center pl-10 pr-10"><div className="text-center">
  <img src={Logo} alt="MyApp Logo" className="h-8 mx-auto"/>
  <p className="text-white mt-2 text-xs font-bold">New Era Education for educational services and school management.</p>
  
  <p className="text-white mt-6 font-bold text-center">Office Hours</p>
  <p className="text-white text-center">Sun - Thu: 10am - 6pm</p></div>

  <div className="mt-6 text-center">
  <div className="flex items-start text-white mb-2 justify-center">
  <FaMapMarkerAlt className="mr-3 mt-0.5" />
  <span><a href="https://maps.app.goo.gl/WemRButxRGPDahpD9?g_st=com.google.maps" className="hover:underline">West Mark Mall Building 2 – 1st floor,<br /> Office 6, 6th of October</a></span></div>
  <div className="flex items-start text-white mb-2 justify-center">
  <FaPhoneAlt className="mr-3 mt-0.5" />
  <a href="tel:+20233043904" className="hover:underline">+2 02 33043904</a></div>
  <div className="flex items-start text-white justify-center">
  <FaEnvelope className="mr-3 mt-0.5" />
  <a href="mailto:info@neweraeducation-eg.com" className="hover:underline"> info@neweraeducation-eg.com</a></div></div>

  <div className="flex justify-end mt-6 space-x-4">
  <a href="#facebook" className="text-white hover:scale-110"><FaFacebookF className="w-5 h-5" /></a>
  <a href="#twitter" className="text-white hover:scale-110"><FaTwitter className="w-5 h-5" /></a>
  <a href="https://www.linkedin.com/company/neweraedu/" target="_blank" rel="noreferrer" className="text-white hover:scale-110"><FaLinkedinIn className="w-5 h-5" /></a>
  <a href="#instagram" className="text-white hover:scale-110"><FaInstagram className="w-5 h-5" /></a></div>
  
  <div className="max-w-max flex-col items-center px-10 w-full mt-6 text-2xs mx-auto">
  <hr className="border-t-[1px] border-gray-600"/>
  <div className="justify-between flex mt-2">
  <a href="/terms" className="hover:underline text-gray-300">Terms & Conditions</a>
  <span className='text-gray-300'>|</span>
  <a href="/policy" className=" hover:underline text-gray-300">Privacy Policy</a></div>
  <p className="text-gray-300 mt-1">&copy; Copyright 2025 by New Era Education site</p></div>
  
  
  </div></footer>
  );
};

export default MobileFooter;